import SashiDo from 'lib/SashiDo';

let currentUser = null;
let currentCustomer = null;
const connectivityError = null;
let products = null;

const AccountManager = {
  init(reload) {
    if (reload) {
      const promiseList = [];

      const currentUserPromise = SashiDo.currentUser().then(({ accountData }) => {
        if (accountData) {
          currentUser = {
            id: accountData.user.objectId,
            email: accountData.user.username,
            name: accountData.user.name,
            pin: accountData.user.pin,
            authData: accountData.user.authData,
            image: (accountData.user.image || {}).url,
            use_gravatar: accountData.user.use_gravatar,
            createdAt: accountData.user.createdAt,
            use_payment_v2: accountData.user.use_payment_v2,

            agreements: {
              privacyPoliciesAcceptedDate: accountData.agreements.privacyPolicies && accountData.agreements.privacyPolicies.createdAt,
              termsOfServiceAcceptedDate: accountData.agreements.termsOfService && accountData.agreements.termsOfService.createdAt,
              privacyNoticeAcceptedDate: accountData.agreements.privacyNoticeAgreement && accountData.agreements.privacyNoticeAgreement.createdAt,
            },

            agreeReceiveNewsletter: accountData.user.agreeReceiveNewsletter,

            backups_enabled: accountData.user.backups_enabled || false,
            backups_enabled_from: accountData.user.backups_enabled_from || false,

            cdn_enabled: accountData.user.cdn_enabled || false,
            cdn_enabled_from: accountData.user.cdn_enabled_from || false,
          };

          currentCustomer = {
            card: accountData.customerInfo.card || null,
            info: accountData.customerInfo.customer || {},
            history: accountData.customerInfo.history || {},
            subscription: accountData.customerInfo.subscription || {},
            addons: accountData.customerInfo.addons || {},

            is_trial: accountData.customerInfo.is_trial,
            subscription_status: accountData.customerInfo.is_active,
            has_payment_method: accountData.customerInfo.has_payment_method,
          };

          products = accountData.products;
        }
      }).catch(err => {
        window.location = '/login';
        return null;
      });

      promiseList.push(currentUserPromise);

      return Promise.all(promiseList).then(() => {
        return {
          currentUser, currentCustomer, products, connectivityError,
        };
      });
    }

    return Promise.resolve({
      currentUser, currentCustomer, products, connectivityError,
    });
  },

  currentUser() {
    return AccountManager.init(!currentUser || !currentCustomer);
  },

  changePassword({ currentPassword, newPassword }) {
    const email = currentUser.email;

    return SashiDo.changePassword({ currentPassword, newPassword, email }).then(({ success, error_message }) => {
      if (success) {
        return { success: true };
      }

      if (error_message) {
        return { error_message };
      }
    });
  },

  changeAvatar(avatar, use_gravatar = false) {
    if (use_gravatar) {
      return SashiDo.changeUserAvatarWithGravatar({ image: null, use_gravatar }).then(() => {
        currentUser.image = '';
        currentUser.use_gravatar = use_gravatar;

        return AccountManager.init();
      });
    }
    return SashiDo.changeUserAvatarWithImage({ image: avatar, use_gravatar }).then((data) => {
      return AccountManager.init();
    });
  },

  setBackupsEnabled({ state, password }) {
    return SashiDo.setBackupsEnabled({ state, password }).then(() => {
      AccountManager.init(true);
    });
  },
};

export default AccountManager;
